import styled from "styled-components";
import {Box} from "rebass";
import {
	backgroundColor,
	border,
	borderBottom,
	borderColor,
	borderRadius,
	borderStyle,
	borderTop,
	bottom,
	boxShadow,
	display,
	height,
	left,
	maxHeight,
	position,
	right,
	top,
	zIndex
} from 'styled-system'


const PositionBox = styled(Box)`
  ${position}
  ${display}
  ${top}
  ${right}
  ${bottom}
  ${left}
  ${borderBottom}
  ${border}
  ${borderTop}
  ${borderStyle}
  ${borderColor}
  ${borderRadius}
  ${zIndex}
	${boxShadow}
	${backgroundColor}
	${maxHeight}
	${height}
`;

export default PositionBox
